// extracted by mini-css-extract-plugin
export default {"noborder":"CoboboxDiemDanhStatus_noborder__F3Poa"};